import HighlightClipInfo from './HighlightClipInfo';

export default HighlightClipInfo;
